import { render, staticRenderFns } from "./TinyMCE.vue?vue&type=template&id=6e8e3ad5&scoped=true&"
import script from "./TinyMCE.vue?vue&type=script&lang=js&"
export * from "./TinyMCE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8e3ad5",
  null
  
)

export default component.exports